import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { minTablet, minDesktop } from '../styles/breakpoints';
import { SecondaryBackColor } from '../styles/colors';

const DESKTOP_WIDTH = 1180;

const Main = styled.main`
  margin-left: 25px;
  margin-right: 25px;

  ${minTablet} {
    margin-left: 40px;
    margin-right: 40px;
  }

  @media (min-width: 980px) {
    padding-top: 50px;
  }

  ${minDesktop} {
    width: ${DESKTOP_WIDTH}px;
    margin-left: auto;
    margin-right: auto;

    background-color: ${SecondaryBackColor};
  }
`;

const PageMainLayout = ({ children }) => (
  <Main>
    { children }
  </Main>
);

PageMainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageMainLayout;



// WEBPACK FOOTER //
// ./src/components/PageMainLayout/PageMainLayout.js